import React from 'react';
import { Form, Row } from 'react-bootstrap';
import { useMyAccount } from '../context/MyAccountContext';

const PinOptionSelector: React.FC = () => {
  const { option, setOption } = useMyAccount();
  return (
    <Form.Group as={Row} className="mb-4">
      <Row sm={12} md={7} xl={5}>
        <Form.Check
          type="radio"
          label="I know my current PIN"
          name="option"
          id="currentPin"
          checked={option === 'currentPin'}
          onChange={() => setOption('currentPin')}
        />
        <Form.Check
          type="radio"
          label="I've forgot my current PIN"
          name="option"
          id="forgotPassword"
          checked={option === 'forgotPassword'}
          onChange={() => setOption('forgotPassword')}
        />
      </Row>
    </Form.Group>
  );
};

export default PinOptionSelector;
